"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M9 0H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V5L9 0zm3 14H4V2h4v4h4v8z"];
//# sourceMappingURL=document.js.map